/** ===============
 *  Socket module
 *  ===============
 */

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

window.addEventListener('beforeunload', () => {
  if (state.socket) {
    state.socket.onclose = null;
    state.socket.close();
  }
});

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
